import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Collapse from 'react-bootstrap/Collapse';
import './stylevn.css';
import SidebarVN from '../../../container/Sidebar/Sidebar-vn';
import { AiOutlineMenu } from 'react-icons/ai';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Dropdown from 'react-bootstrap/Dropdown';
import { useHistory } from 'react-router-dom';
import { DropdownButton } from 'react-bootstrap';
import langData from '../../../translations/translations.json';
import "../../../Style/typo.css"

// const navItems = [
//     { text: 'Private Cloud', href: 'https://hanbiro.com/#/vi/private-cloud#cluster', active: true },
//     { text: 'Dịch vụ', href: 'https://hanbiro.vn/#services', },
//     { text: 'Groupware', href: 'https://hanbiro.vn/#groupware' },
//     { text: 'Liên hệ', href: 'https://hanbiro.vn/#contact' },
// ];

function HeaderVn({ lang = 'vi' }) {
    const [show, setShow] = useState(false);
    const [open, setOpen] = useState(false);
    const history = useHistory();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleLanguageChange = (path) => {
        history.push(path);
    };

    const headerContent = langData.header;

    const navItems = [
        { text: headerContent['private-cloud'][lang], href: 'https://hanbiro.vn/cloud/#/vi/private-cloud#cluster', active: true },
        { text: headerContent['services'][lang], href: 'https://hanbiro.vn/#services' },
        { text: headerContent['groupware'][lang], href: 'https://hanbiro.vn/#groupware' },
        { text: headerContent['contact'][lang], href: 'https://hanbiro.vn/#contact' }
    ];

    const renderNavList = () => (
        <div className="navbar-list">
            <ul className="navbar-nav">
                {navItems.map((item, index) => (
                    <li className="navbar-item" key={index}>
                        <a
                            className={`nav-link typo-14 ${item.active ? 'active' : ''}`}
                            aria-current={item.active ? 'page' : undefined}
                            href={item.href}
                        >
                            {item.text}
                        </a>
                    </li>
                ))}
            </ul>
            <div className="head-drop-sub">
                <DropdownButton
                    align="end"
                    title="Tiếng Việt"
                    id="dropdown-menu-align-end"
                >
                    <Dropdown.Item href="https://hanbiro.com/#/en/home">English</Dropdown.Item>
                    <Dropdown.Item href="https://hanbiro.com">Korean</Dropdown.Item>
                </DropdownButton>
            </div>
        </div>
    );

    return (
        <>
            <div className="head-wrap head-vn-desk">
                <div className="fit-width">
                    <div className="nav-vn">
                        <a href="https://hanbiro.vn/"><img src="https://hanbiro.com/cloud/library/banner/hanbiro.svg" alt="error" /></a>
                        {renderNavList()}
                    </div>
                </div>
            </div>

            <div className="header-vn-mb">
                <div className="fit-width nav-vn-block">
                    <div className="nav-vn">
                        <Button variant="primary" onClick={handleShow}>
                            <AiOutlineMenu className="icon-menu" />
                        </Button>

                        <Offcanvas show={show} onHide={handleClose} placement="top" className="sidebar-menu">
                            <Offcanvas.Header closeButton />
                            <Offcanvas.Body>
                                <SidebarVN />
                            </Offcanvas.Body>
                        </Offcanvas>
                        <a href="https://hanbiro.vn/"><img src="https://hanbiro.com/cloud/library/banner/hanbiro.svg" alt="error" /></a>
                    </div>

                    <div className="head-dropdown">
                        <Button onClick={() => setOpen(!open)} aria-controls="collapse-header" aria-expanded={open}>
                            <MoreVertIcon className="icon-menu" />
                        </Button>
                    </div>
                </div>

                <Collapse in={open}>
                    <div id="collapse-header">
                        {renderNavList()}
                    </div>
                </Collapse>
            </div>
        </>
    );
}

export default HeaderVn;
